import PropTypes from 'prop-types';

import PreviewableNames from 'components/atoms/PreviewableNames';

import './index.scss';

// The brand as its logo, falling back to its name for the brands that have no
// image on file - which is most of them (see components/atoms/PreviewableNames
// for the text treatment those rows keep).
//
// The picture is fitted to the row rather than the row to the picture: in a
// table cell it is laid out over the full height of the row less 1px top and
// bottom, so a logo can never be the thing that makes a row tall - which is why
// this column was text-only until now. It is scaled with `contain`, so it fills
// that height without ever being stretched out of shape.
const BrandLogo = ({ src, name }) =>
  src ? (
    <span className="brand-logo">
      <img className="brand-logo__img" src={src} alt={name || ''} title={name || undefined} />
    </span>
  ) : (
    <PreviewableNames items={[{ name }]} />
  );

BrandLogo.propTypes = {
  src: PropTypes.string,
  name: PropTypes.string,
};

export default BrandLogo;
